var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDislike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.0002L6 13.9887V2.98863L2 3.0001L2 14.0002Z",
    fill: "#F56A50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.15 19.4829C17.15 21.3143 14 21.3143 14 20.3986C14.2441 16.1773 12.1273 14.2386 10.5363 13.2947C10.2129 13.1028 10 12.7634 10 12.3874V4.50014C10 3.94785 10.4473 3.50013 10.9996 3.50014L16 3.50012C17 3.50002 16.7 3.50012 18.5 3.50012C19.5 3.50012 20.6689 4.74264 21 6.00012C21.3312 7.2576 22 10.5844 22 11.5001C22 12.4158 21.9 13.9888 20.1 13.9888H18.1489C17.5966 13.9888 17.15 14.4365 17.15 14.9887V19.4829Z",
    fill: "#F56A50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.0002L6 13.9887V2.98863L2 3.0001L2 14.0002Z",
    stroke: "#F56A50",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.15 19.4829C17.15 21.3143 14 21.3143 14 20.3986C14.2441 16.1773 12.1273 14.2386 10.5363 13.2947C10.2129 13.1028 10 12.7634 10 12.3874V4.50014C10 3.94785 10.4473 3.50013 10.9996 3.50014L16 3.50012C17 3.50002 16.7 3.50012 18.5 3.50012C19.5 3.50012 20.6689 4.74264 21 6.00012C21.3312 7.2576 22 10.5844 22 11.5001C22 12.4158 21.9 13.9888 20.1 13.9888H18.1489C17.5966 13.9888 17.15 14.4365 17.15 14.9887V19.4829Z",
    stroke: "#F56A50",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.787f8769d2c929fc600fe2f75abbcc2a.svg";
export { ForwardRef as ReactComponent };